module.exports = __webpack_public_path__ + "media/images/icon/payment/union-pay-d18924c66c6eeb73212334f2c5de9a1f.svg";